import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { CONTACT } from "../data/content";

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

export const WhatsAppFab = () => (
  <a
    href={CONTACT.whatsapp}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-fab"
    className="fixed bottom-6 right-6 z-[90] h-14 w-14 grid place-items-center rounded-full bg-emerald-600 text-white shadow-2xl shadow-emerald-900/40 hover:bg-emerald-500 hover:scale-110 transition-[transform,background-color] duration-300"
    aria-label="WhatsApp Chat"
  >
    <MessageCircle className="h-6 w-6" />
    <span className="absolute inset-0 rounded-full bg-emerald-500 animate-ping opacity-20" />
  </a>
);
